import {Component, Input, OnInit} from '@angular/core';
import {Connection} from "../modbusData";

@Component({
  selector: 'app-modbusnetworkdetails',
  templateUrl: './modbusnetworkdetails.component.html',
  styleUrls: ['./modbusnetworkdetails.component.css']
})
export class ModbusnetworkdetailsComponent implements OnInit {
  @Input()  connection: Connection | undefined;

  constructor() { }

  ngOnInit(): void {
  }

}
